import Lottie from "lottie-react";
import animationData from "./syncing.json";

interface LottieAnimationProps {
  height?: number;
  width?: number;
  loop?: boolean;
}

export function SyncingLottieAnimation({
  height = 300,
  width = 300,
  loop = true,
}: LottieAnimationProps) {
  return (
    <div style={{ height, width }}>
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
}
